import {Security} from '../security';
import {SecurityKey} from '../security-key';
import {ArrayEncodedMdEntry} from './array-encoded-md-entry';

export enum MdMessageFieldIndex {
    REQ_ID,
    SECURITY_INCREMENT_ID,
    ENTRIES,
    SECURITY_KEY
}

export type ArrayEncodedMdMessage = [
    string,                 // mdReqId
    number,                 // securityIncrementId
    ArrayEncodedMdEntry[],  // mdEntries
    Security | SecurityKey  // security
    ];

export interface ArrayEncodedMdSnapshotMessage extends ArrayEncodedMdMessage {
    [MdMessageFieldIndex.SECURITY_KEY]: Security;
}

export interface ArrayEncodedMdUpdateMessage extends ArrayEncodedMdMessage {
    [MdMessageFieldIndex.SECURITY_KEY]: SecurityKey;
}
